module.exports = __webpack_public_path__ + "static/t-nav-2-c61cd0c24b24275689194560086316db.png";